import { Routes } from '@angular/router';

const termsConditionsRoute = {
    path: 'terms-conditions',
    loadChildren: () =>
        import('../pages/terms-conditions/terms-conditions.routes').then(
            m => m.TERMS_CONDITIONS_ROUTES,
        ),
};

const privacyPolicyRoute = {
    path: 'privacy-policy',
    loadChildren: () =>
        import('../pages/privacy-policy/privacy-policy.routes').then(
            m => m.PRIVACY_POLICY_ROUTES,
        ),
};

const cookiePolicyRoute = {
    path: 'cookie-policy',
    loadChildren: () =>
        import('../pages/cookie-policy/cookie-policy.routes').then(
            m => m.COOKIE_POLICY_ROUTES,
        ),
};

export const policyRoutes: Routes = [
    termsConditionsRoute,
    privacyPolicyRoute,
    cookiePolicyRoute,
];
